
<div class="spinner-input-container">
    <div class="text spinner-input-text highlighted" *ngIf="title">{{title}}</div>
    <div class="spinner-input-row">
        <div class="increment-button highlighted not-selectable " (click)="incrementDown()">-</div>
        <div class="spinner-input-value-label spinner-input-text not-selectable text">{{value}}</div>
        <div class="increment-button highlighted not-selectable " (click)="incrementUp()">+</div>
    </div>
</div>